import React from 'react'

import clsx from 'clsx'

import Typography from 'components/Typography'
import { formatRatingAverage } from 'helpers/formatters'

import classes from './RatingNum.module.scss'

/** @type {import('./types').default} */
const RatingNum = ({ rating, xs = false }) => {
  return (
    <Typography className={clsx(classes.rating, 'RatingNum', { [classes.xs]: xs })}>
      {formatRatingAverage(rating)}
    </Typography>
  )
}

export default RatingNum
